<a *ngIf="item" #filelink href="{{'/files/' + item.file}}" (click)="openFile($event, '/files/' + item.file,item.text)" target="_blank">
  {{ item?.translation_key||item?.text  | translation|translationFromString | transformText :item?.text_transform }}
</a>
